<template>
    <div class="body">
        <div style="margin-bottom: 3rem;">
            <div style="text-align: center; font-size: 2rem; font-weight: bold; margin-bottom: 1rem;">
                移动积分兑换
            </div>

            <div style="margin-bottom: 1rem;">
                <div style="font-weight: bold;">请先选择要兑换的商品类别：</div>
                <van-radio-group v-model="query.goodsClass" direction="horizontal">
                    <van-radio v-for="item in goodsClassList" :key="item" :name="item" @click="clickGoodsClass" icon-size="1.5rem">
                        {{goodsClassMap[item].name}}
                    </van-radio>
                </van-radio-group>
            </div>

            <div style="margin-bottom: 1rem;">
                第一步：登录查询
                <van-field v-model="query.phone" label="手机号码" placeholder="手机号码" clearable/>
                <van-row>
                    <van-col span="18">
                        <van-field v-model="query.loginCode" label="验证码" placeholder="验证码" clearable/>
                    </van-col>
                    <van-col span="6">
                        <van-button size="small" type="warning" @click="getLoginCode">获取验证码</van-button>
                    </van-col>
                </van-row>
                <van-row style="text-align:center;">
                    <van-button round size="large" type="warning" style="height:3.2rem;" @click="login">立即登录</van-button>
                </van-row>
                <div v-if="creditNum" style="font-size:1.5rem;font-weight:bold;">当前用户移动积分数：{{creditNum}}</div>
            </div>

            <div style="margin-bottom: 1rem;">
                第二步：上报登记
                <van-field v-model="query.phone" label="兑换手机" placeholder="注意，手机号输错无法回款" clearable/>
                <van-field v-model="query.receiver" label="收件人" placeholder="收件人" clearable/>
                <van-field v-model="query.phone" label="收件手机" placeholder="收件手机" clearable/>
                <van-field v-model="query.area" label="所在地区" placeholder="所在地区" clearable @click="show=true"/>
                <van-field v-model="query.district" label="所在街道" placeholder="所在街道" clearable/>
                <van-field v-model="query.address" label="详细地址" placeholder="详细地址" clearable/>

                <div style="text-align:center;">
                    <van-button round size="large" type="warning" style="height:3.2rem;" @click="regist">提交上报登记</van-button>
                </div>
            </div>

            <div style="margin-bottom: 1rem;">
                第三步：兑换积分
                <div style="margin-bottom: 1rem;">
                    <div style="font-weight: bold;">请选择要兑换的商品：</div>
                    <van-radio-group v-model="query.goodId">
                        <van-radio v-for="(value, key) in goodsClassMap[query.goodsClass].goodsMap"
                                   :key="key" :name="key" style="font-size:1rem;" icon-size="1.2rem">
                            {{value}}
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>

            <van-field v-model="query.count" label="产品数量" placeholder="产品数量" clearable/>
            <van-field v-model="query.phone" label="手机号码" placeholder="注意，手机号输错无法回款" clearable/>
            <van-row>
                <van-col span="18">
                    <van-field v-model="query.exchangeCode" label="验证码" placeholder="验证码" clearable/>
                </van-col>
                <van-col span="6">
                    <van-button size="small" type="warning" @click="getExchangeGoodsCode">获取验证码</van-button>
                </van-col>
            </van-row>

            <van-row style="text-align:center;">
                <van-button round size="large" type="warning" style="height:3.2rem;" @click="exchangeGoods">提交兑换</van-button>
            </van-row>
        </div>

        <van-row>
            1、<span style="font-weight: bold;">兑换区域：</span>{{goodsClassMap[query.goodsClass].area}}
            （不同商品类别兑换区域不同）
        </van-row>
        <van-row>
            2、实物兑换，是移动商城会寄礼品到快递地址，无须私下再给客户礼品！建议直接寄到客户家里！
        </van-row>

        <van-popup v-model="show" position="bottom">
            <van-picker show-toolbar title="地区选择" :columns="areaTreeList" @confirm="onAreaConfirm"/>
        </van-popup>
    </div>
</template>

<script>
    import creditAPI from '@/api/credit';

    export default {
        data() {
            return {
                goodsClassList: ["10140", "10134", "10133"],
                goodsClassMap: {
                    "10133": {
                        name: "咪咕实物(广东)",
                        area: "广东(限制地区：吉林,黑龙江,湖北,海南,四川,云南,甘肃,青海,内蒙古,广西,西藏,新疆,北京,辽宁,山西,重庆,宁夏,河南,湛江,陕西,河北,温州,江西、上海、浙江,江苏,山东、贵州、湖南、福建、安徽)",
                        goodsMap: {
                            "11149699": "咪咕CBA系列三层抽纸（限量版）21包[18570积分]",
                            "11149698": "咪咕CBA系列三层抽纸（限量版）18包[15920积分]",
                            "11119765": "米狗智能电动牙刷MX602[19700积分]",
                            "11119766": "米狗电动牙刷MX213[14700积分]",
                            "11175750": "悦丽雅清莹薄透防晒乳SPF45[16700积分]",
                            "11077156": "咪咕床上四件套[25020积分]",
                            "11077135": "咪咕抗菌驱蚊夏凉被[17060积分]",
                            "11145261": "纤维保湿净化面膜[10700积分]",
                            "11149689": "咪咕 CBA系列笔记本2本[14490积分]",
                            "11149688": "咪咕 CBA系列笔记本单本[7250积分]",
                            "11149710": "咪咕CBA系列抱枕被（限量版）[18090积分]",
                            "11148196": "咪咕非医用 一次性防护口罩100个[25020积分]",
                            "11148195": "咪咕非医用 一次性防护口罩80个[20020积分]",
                            "11148194": "咪咕非医用 一次性防护口罩60个[15020积分]",
                            "11148193": "咪咕非医用 一次性防护口罩50个[12520积分]",
                            "11148192": "咪咕非医用 一次性防护口罩40个[10020积分]",
                            "11148191": "咪咕非医用 一次性防护口罩30个[7520积分]",
                            "11148190": "咪咕非医用 一次性防护口罩20个[5020积分]",
                            "11148189": "咪咕非医用 一次性防护口罩10个[2520积分]",
                            "11148188": "咪咕非医用 一次性防护口罩5个[1550积分]",
                            "11078685": "咪咕高级记忆枕[12290积分]",
                            "11077158": "咪咕旅行枕[8550积分]",
                            "11077278": "咪咕创意LED小台灯[16720积分]",
                            "11077121": "咪咕多功能毯CD-05[11270积分]",
                            "11121455": "米狗洁面仪520[17500积分]",
                        },
                    },
                    "10134": {
                        name: "实物",
                        area: "山东,湖南、福建,江西,广东(限制地区：重庆,宁夏,北京,河南,云南,广西,海南,吉林,黑龙江,青海,内蒙古,西藏,新疆,陕西,河北,山西,甘肃,海宁,江苏,浙江,安徽,上海)",
                        goodsMap: {
                            "11202275": "陆裕 葡萄牙式刀叉餐具套装，白色礼盒[8900积分]",
                            "11201113": "陆裕 智能保温杯 500ml，月光白[6900积分]",
                            "11201112": "陆裕 智能保温杯 500ml，亚光黑[6900积分]",
                            "11198736": "陆裕不锈钢真空保温壶2L本色[9800积分]",
                            "11198735": "陆裕不锈钢真空保温壶2L酒红色[11010积分]",
                            "11197984": "陆裕 不锈钢小汤锅16cm[5800积分]",
                            "11197939": "陆裕 不锈钢内胆泡面碗1200ml[4580积分]",
                            "11178282": "榄菊(Lanju) 菊之语净白去渍洗衣液 2kg*1瓶[4800积分]",
                        },
                    },
                    "10140": {
                        name: "咪咕实物z",
                        area: "天津,山西,上海,江苏,内蒙古,浙江,安徽,福建,江西,山东,湖北,湖南,广东,海南,四川,贵州,陕西(限制地区：河北,辽宁,吉林,黑龙江,广西,重庆,云南,新疆,西藏,甘肃,青海,宁夏,河南)",
                        goodsMap: {
                            "11194989": "驼人 一次性口罩10只装成人医用外科口罩[5000积分]",
                            "11186430": "洁美睿毛巾[5000积分]",
                            "11155266": "天一童书儿童必读童话故事第二季 全套6册[9040积分]",
                            "11155466": "天一童书麻小烦成长记全12册[16950积分]",
                        },
                    },
                },
                query: {
                    traderId: this.$route.query.traderId,
                    goodId: "",
                    goodName: "",
                    goodsClass: "10140",
                    phone: "",
                },
                creditNum: null,
                areaTreeList: [],
                show: false,
            }
        },
        methods: {
            clickGoodsClass() {
                this.query.goodId = '';
            },
            onAreaConfirm(value, index) {
                this.show = false;
                this.query.area = value.join('|');
            },
            getLoginCode() {
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("手机号不正确");
                    return;
                }
                this.$toast.loading({forbidClick: true});
                creditAPI.getLoginCode(this.query.phone, this.query.goodsClass).then((result) => {
                    this.$toast.clear();
                    if (result && result.data && result.data.data && result.data.data.Data) {
                        this.creditNum = result.data.data.Data;
                        this.$toast("用户已登录");
                    } else {
                        this.$toast("发送成功");
                    }
                }).catch(() => {
                });
            },
            login() {
                if (!this.query.loginCode) {
                    this.$toast("请输入验证码");
                }
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("手机号不正确");
                    return;
                }
                this.$toast.loading({forbidClick: true});
                creditAPI.login(this.query.phone, this.query.loginCode, this.query.goodsClass).then((result) => {
                    this.$toast.clear();
                    if (result && result.data && result.data.data && result.data.data.Data) {
                        this.creditNum = result.data.data.Data;
                        this.$toast("登录成功");
                    } else {
                        this.$toast("积分查询失败");
                    }
                }).catch(() => {
                });
            },
            regist() {
                if (!this.query.phone || !this.query.receiver || !this.query.area || !this.query.district
                    || !this.query.address || !this.query.goodsClass) {
                    this.$toast("请先填写信息");
                }
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("手机号不正确");
                    return;
                }
                this.query.addr = this.query.area + '|' + this.query.district + '|' + this.query.address;
                this.$toast.loading({forbidClick: true});
                creditAPI.regist(this.query.phone, this.query.receiver, this.query.addr, this.query.goodsClass).then((result) => {
                    this.$toast.clear();
                    if (result && result.data && result.data.data && result.data.data.ErrorMsg) {
                        this.$toast(result.data.data.ErrorMsg);
                    } else {
                        this.$toast("登记失败");
                    }
                }).catch(() => {
                });
            },
            getExchangeGoodsCode() {
                if (!this.query.phone || !this.query.goodId || !this.query.goodPoints || !this.query.goodsClass || !this.query.count) {
                    this.$toast("请先填写信息");
                }
                this.query.goodName = this.goodsClassMap[this.query.goodsClass].goodsMap[this.query.goodId];
                if (!this.query.goodName) {
                    this.$toast("该商品不存在");
                    return;
                }
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("手机号不正确");
                    return;
                }
                let goodNameArr = this.query.goodName.replace('积分]', '').split('[');
                this.query.goodPoints = goodNameArr[1];
                this.$toast.loading({forbidClick: true});
                creditAPI.getExchangeGoodsCode(this.query.phone, this.query.goodId, this.query.goodPoints, this.query.goodsClass, this.query.count).then((result) => {
                    this.$toast.clear();
                    if (result && result.data && result.data.data && result.data.data.ErrorMsg) {
                        this.$toast(result.data.data.ErrorMsg);
                    } else {
                        this.$toast("登记失败");
                    }
                }).catch(() => {
                });
            },
            exchangeGoods() {
                if (!this.query.traderId) {
                    this.$toast("页面参数有误，请重新进入页面");
                    return;
                }
                if (!this.query.goodsClass || !this.query.goodId || !this.query.count
                    || !this.query.phone || !this.query.exchangeCode) {
                    this.$toast("请先填写信息");
                    return;
                }
                this.query.goodName = this.goodsClassMap[this.query.goodsClass].goodsMap[this.query.goodId];
                if (!this.query.goodName) {
                    this.$toast("该商品不存在");
                    return;
                }
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("手机号不正确");
                    return;
                }
                let goodNameArr = this.query.goodName.replace('积分]', '').split('[');
                this.query.goodPoints = goodNameArr[1];
                this.$toast.loading({forbidClick: true});
                creditAPI.exchangeGoods(this.query).then((result) => {
                    this.$toast.clear();
                    if (result && result.data && result.data.data && result.data.data.ErrorMsg) {
                        this.$toast(result.data.data.ErrorMsg);
                    } else {
                        this.$toast("兑换失败");
                    }
                }).catch(() => {
                });
            },
        },
        created() {
            creditAPI.getAddress().then((result) => {
                if (result && result.data) {
                    let areaTree = result.data.info;
                    if (areaTree) {
                        areaTree.map(e => {
                            e.text = e.value;
                            e.children = e.childs;
                            if (e.children) {
                                e.children.map(e2 => {
                                    e2.text = e2.value;
                                    e2.children = e2.childs;
                                    if (e2.children) {
                                        e2.children.map(e3 => {
                                            e3.text = e3.value;
                                            e3.children = e3.childs;
                                            if (e3.children) {
                                                e3.children.map(leaf => {
                                                    leaf.text = leaf.value;
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        });
                        this.areaTreeList = areaTree;
                    }
                }
            }).catch(() => {
            });
        },
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #FFFFFF;
    }

    .body {
        padding: 2rem 2rem;
        line-height: 2.5rem;
        p {
            text-align: center;
            color: #000000;
        }
        img {
            height: 25rem;
            width: 18rem;
        }

    }

</style>
